import { CityState, DataSource, HorizontalSpacer, Label, Layout, LayoutHeader, Map, Panel, SearchButton, Splitter, Switch, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutProspectFindNear extends Layout {
    buttonSearch: SearchButton;
    citystateNear: CityState;
    horizontalspacer1: HorizontalSpacer;
    labelFindProspectsWithType: Label;
    labelMilesOf: Label;
    labelWithin: Label;
    layoutheaderProsFindNear: LayoutHeader;
    mapFindNear: Map;
    panel1: Panel;
    sourceProspect: DataSource;
    splitter: Splitter;
    switchPlotOnMap: Switch;
    tableFindNear: Table;
    textboxCategory: Textbox;
    textboxFindNearRadius: Textbox;
}
